module.exports = __webpack_public_path__ + "media/images/lb/237-c686862c9fce0ffc3c7f64bc29152c33.svg";